import { render, staticRenderFns } from "./platformPlateList.vue?vue&type=template&id=63ce68e2&scoped=true"
import script from "./platformPlateList.vue?vue&type=script&lang=js"
export * from "./platformPlateList.vue?vue&type=script&lang=js"
import style0 from "./platformPlateList.vue?vue&type=style&index=0&id=63ce68e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce68e2",
  null
  
)

export default component.exports